/**
 * Shared design tokens for the Noki Copilot overlay.
 *
 * Self-contained on purpose — the copilot is a floating overlay that
 * shouldn't inherit noki-fe's wider MUI theme so its look stays
 * consistent across themes/clients. If you change a color here, change
 * it everywhere — there's no theme provider.
 */

export const tokens = {
  ink: {
    50: "#F8FAFC",
    100: "#E2E8F0",
    200: "#CBD5E1",
    300: "#94A3B8",
    400: "#64748B",
    500: "#475569",
    900: "#0F172A",
  },
  accent: {
    cyan: "#67E8F9",
    cyanStrong: "#06B6D4",
    violet: "#C4B5FD",
    violetStrong: "#8B5CF6",
  },
  surface: {
    panel: "rgba(15, 23, 42, 0.78)",
    panelLight: "rgba(30, 41, 59, 0.55)",
    border: "rgba(255, 255, 255, 0.08)",
    borderStrong: "rgba(255, 255, 255, 0.14)",
  },
  shadow: {
    panel: "0 30px 80px -30px rgba(8, 47, 73, 0.45), 0 12px 32px -12px rgba(99, 102, 241, 0.25)",
    button: "0 12px 28px -8px rgba(139, 92, 246, 0.45), 0 4px 12px rgba(8, 11, 17, 0.4)",
    glow: "0 0 0 6px rgba(139, 92, 246, 0.18), 0 0 32px 4px rgba(103, 232, 249, 0.25)",
  },
};

export const glassPanelStyle = {
  background: tokens.surface.panel,
  backdropFilter: "blur(28px) saturate(160%)",
  WebkitBackdropFilter: "blur(28px) saturate(160%)",
  border: `1px solid ${tokens.surface.border}`,
  boxShadow: tokens.shadow.panel,
};
